import { render, staticRenderFns } from "./Filter-top.vue?vue&type=template&id=53848322&scoped=true&lang=pug"
import script from "./Filter-top.vue?vue&type=script&lang=js"
export * from "./Filter-top.vue?vue&type=script&lang=js"
import style0 from "./Filter-top.vue?vue&type=style&index=0&id=53848322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53848322",
  null
  
)

export default component.exports